import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import FormGroup from 'reactstrap/lib/FormGroup';
import Input from 'reactstrap/lib/Input';
import Label from 'reactstrap/lib/Label';
import { IMaskInput } from 'react-imask';
import classnames from 'classnames';

export function FormInput({
  id,
  name,
  type = 'text',
  value = '',
  label = '',
  placeholder = undefined,
  pattern = undefined,
  onChange,
  onBlur,
  disabled = false,
  options = undefined,
  className = null,
  labelClassName = null,
  inputClassName = null,
  validationClass = null,
}) {
  const inputTagRef = useRef();

  const onAcceptHandler = useCallback(
    (_, inputRef) => {
      onChange({ target: { value: inputRef.unmaskedValue, name } });
    },
    [name, onChange]
  );

  const onBlurHandler = useCallback(
    event => {
      onBlur({ target: { value: inputTagRef?.current?.maskRef?.unmaskedValue ?? event.target.value, name } });
    },
    [name, onBlur]
  );

  const InputElement = pattern ? IMaskInput : Input;
  const inputProps = pattern
    ? {
        ref: inputTagRef,
        mask: pattern,
        unmask: false,
        lazy: !value.length,
        onAccept: onAcceptHandler,
        onBlur: onBlurHandler,
      }
    : {};

  return (
    <FormGroup
      className={classnames(
        'form-input d-flex flex-column flex-md-row align-items-md-center form-group',
        className,
        validationClass,
        'form-group'
      )}
      noMargin
    >
      <Label className={classnames('text-nowrap', labelClassName)} for={id}>
        {label}&nbsp;
      </Label>
      <InputElement
        name={name}
        type={type}
        id={id}
        placeholder={placeholder}
        className={classnames('form-control text-truncate', inputClassName)}
        value={value}
        onChange={onChange}
        onBlur={onBlurHandler}
        disabled={disabled}
        {...inputProps}
      >
        {options &&
          options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
      </InputElement>
    </FormGroup>
  );
}

FormInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  pattern: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  validationClass: PropTypes.string,
};
